import flowRight from 'lodash/flowRight'

import appContext from './application-context'
import setupEnvironment from './environment'
import setupGlobalFlash from './global-sf-flash'
import setupStimulus from './stimulus'
import setupTooltip from './tooltip'

export default (): void => {
  flowRight([setupEnvironment, setupStimulus, setupGlobalFlash, setupTooltip])(
    appContext
  )
}
